export class ScopeService {
    constructor(axios, apiUrl) {
      this.$axios = axios;
      this.apiUrl = apiUrl;
    }

    /**
     * Gets the scope by ID
     * @param {integer} id 
     * @returns 
     */
    async getScope(id) {
        return await this.$axios.gets(
            this.apiUrl + "Sessions/session/" + id
        ).then(function(response) {
            return response.data;
        })
        .catch(function(error) {
            return {error: error, response: error.response?.data };
        });
    }

    async getScopeByBranchCustomer(sqldbid, custNo) {
        return await this.$axios.get(
            `${this.apiUrl}Sessions/Customer/${custNo}/Company/${sqldbid}/Latest`
        ).then((response) => {
            return response.data;
        }).catch((error) => {
            return {error: error, response: error.response?.data };
        });
    }
  
    /**
     * Data should contain some of the following:
     * sqldbid, custNo, ndc, orderId
     * @param {*} data 
     * @returns 
     */
    async createScope(data) {

        var scope1 = undefined;
        var scope2 = undefined;

        var promises = [];

        promises.push(
            this.$axios.post(
                this.apiUrl + "Sessions/session",
                data
            ).then(function(response) {
                scope1 = response.data;
            })
            .catch(function(error) {
                return {error: error, response: error.response.data };
            })
        );

        if ('custNo' in data) {
            promises.push(
                this.$axios.post(
                    this.apiUrl + "Sessions/session",
                    {
                        sqldbid: data.sqldbid,
                        custNo: 0
                    }
                ).then(function(response) {
                    scope2 = response.data;
                })
                .catch(function(error) {
                    return {error: error, response: error.response.data };
                })
            );
        }
        
        await Promise.all(promises);

        if (scope1 && scope2) {
            scope1['franchiseOnlyScope'] = scope2;
        }

        return scope1; 
    }

    /**
     * Update scope
     * Data should contain some of the following:
     * sqldbid, custNo, ndc, orderId
     * @param {*} data 
     * @returns 
     */
    async updateScope(id, data) {
        return await this.$axios.put(
            this.apiUrl + "Sessions/session/" + id + "/Scope" ,
            data
        ).then(function(response) {
            return response.data;
        })
        .catch(function(error) {
            return {error: error, response: error.response.data };
        });
    }

    /**
     * Update scope
     * Data should contain some of the following:
     * sqldbid, custNo, ndc, orderId
     * @param {*} data 
     * @returns 
     */
     async removeFromScope(id) {
        return await this.$axios.put(
            this.apiUrl + "Sessions/session/" + id + "/UnScope" ,
            data
        ).then(function(response) {
            return response.data;
        })
        .catch(function(error) {
            return {error: error, response: error.response.data };
        });
    }
  }
  